export default {
    // 当前语言模式  zh / en 
    lang: '',
    langPack: ['zhCN'],
    theme: localStorage.getItem('THEME') || 'dark',
    currentMenu:'',
    autoSignin:false
}